

export function toYYYYMMDD(value:Moment|MomentDate|null):string | null {

    if (!value) return null

    return value.format("YYYY-MM-DD")
}